export const extra = {
  fr: {
    blog: {
      eyebrow: "Ressources",
      title: "Guides & articles pour piloter votre réseau",
      subtitle:
        "Conseils terrain, bonnes pratiques et retours d'expérience pour les réseaux de restauration et de retail.",
      readMore: "Lire l'article",
      back: "Tous les articles",
      empty: "Aucun article publié pour le moment.",
      publishedOn: "Publié le",
      ctaTitle: "Envie d'aller plus loin ?",
      ctaText: "Découvrez comment Orbit concrétise ces bonnes pratiques dans votre réseau.",
      ctaButton: "Demander une démo",
    },
    modulePages: {
      common: {
        subFeaturesTitle: "Ce que vous pouvez faire",
        benefitsTitle: "Pourquoi vos équipes vont l'adopter",
        backLink: "Tous les modules",
        nextLabel: "Module suivant",
        demoButton: "Demander une démonstration",
      },
      intranet: {
        intro:
          "Fini les informations perdues entre emails, affichages et groupes de discussion. L'Intranet Orbit centralise toute la vie de votre réseau dans un espace unique, accessible à chaque collaborateur selon son rôle.",
        subFeatures: [
          {
            title: "Communications ciblées",
            text: "Diffusez la bonne information au bon public : par magasin, par région, par rôle ou par enseigne, avec suivi de lecture.",
          },
          {
            title: "OrbitGram, le réseau social interne",
            text: "Photos de vitrines, réussites, défis entre magasins : vos équipes partagent leurs succès et s'engagent au quotidien.",
          },
          {
            title: "Ressources & annuaire",
            text: "Documents, procédures, formations et contacts : tout se retrouve en quelques secondes grâce à la recherche globale et aux favoris.",
          },
        ],
        benefits: [
          {
            title: "Une information qui atteint le terrain",
            text: "Mesurez qui a lu quoi, et relancez les magasins qui n'ont pas pris connaissance.",
          },
          {
            title: "Des équipes plus engagées",
            text: "La reconnaissance publique et les défis créent une vraie vie de réseau.",
          },
          {
            title: "Zéro email perdu",
            text: "Toutes les communications sont centralisées, consultables et archivées.",
          },
        ],
      },
      operations: {
        intro:
          "Le Centre des opérations est le poste de commandement de vos animateurs et managers réseau : une vision consolidée de chaque point de vente, des alertes priorisées et des outils pour agir sans attendre.",
        subFeatures: [
          {
            title: "Carte & portefeuille multi-sites",
            text: "Visualisez l'état de chaque magasin sur une carte en temps réel : conformité, performance, incidents en cours.",
          },
          {
            title: "Alertes & plans d'action",
            text: "Les écarts remontent automatiquement. Affectez des actions, fixez des échéances et suivez leur avancement.",
          },
          {
            title: "Visites, audits & benchmarks",
            text: "Préparez vos visites, digitalisez vos grilles d'audit et comparez vos magasins pour diffuser les meilleures pratiques.",
          },
        ],
        benefits: [
          {
            title: "Des priorités évidentes",
            text: "Vos managers savent chaque matin où concentrer leur temps, et pourquoi.",
          },
          {
            title: "Un suivi sans angle mort",
            text: "Chaque action est tracée jusqu'à validation, magasin par magasin.",
          },
          {
            title: "Un réseau qui progresse",
            text: "Les classements stimulent et les meilleurs élèves inspirent les autres.",
          },
        ],
      },
      kpi: {
        intro:
          "Arrêtez de courir après les chiffres. Le module KPI consolide automatiquement vos données de vente, de marge et d'activité, et les rend lisibles à tous les niveaux de votre organisation.",
        subFeatures: [
          {
            title: "Indicateurs métier consolidés",
            text: "CA, marge, foodcost, démarque, objectifs, N-1 et like-for-like : vos données sources sont fiabilisées et harmonisées.",
          },
          {
            title: "Comparatifs & classements",
            text: "Comparez magasins, secteurs et périodes en un clic. Détectez instantanément les écarts de performance.",
          },
          {
            title: "Analyse par l'IA Orbit",
            text: "Posez vos questions en langage naturel : l'IA analyse vos données, explique les écarts et propose des recommandations.",
          },
        ],
        benefits: [
          {
            title: "Des décisions plus rapides",
            text: "Des données claires et à jour, accessibles sans attendre les rapports hebdomadaires.",
          },
          {
            title: "Un langage commun",
            text: "Siège et terrain parlent des mêmes chiffres, au même moment.",
          },
          {
            title: "L'IA au service du terrain",
            text: "Les recommandations automatiques transforment l'analyse en actions concrètes.",
          },
        ],
      },
      support: {
        intro:
          "Le module support remplace les chaînes d'emails et les appels dispersés par un centre de demandes unique : chaque sollicitation du terrain est tracée, affectée et suivie jusqu'à résolution.",
        subFeatures: [
          {
            title: "Demandes multi-services",
            text: "RH, maintenance, achats, marketing, qualité : le magasin formule sa demande, Orbit l'aiguille vers le bon service.",
          },
          {
            title: "SLA & affectation intelligente",
            text: "Priorités, délais de traitement et affectations automatiques : plus rien ne tombe entre les mailles du filet.",
          },
          {
            title: "Timeline & transparence",
            text: "Le magasin suit l'avancement de sa demande en temps réel ; le manager garde la visibilité sur tout son secteur.",
          },
        ],
        benefits: [
          {
            title: "Des délais drastiquement réduits",
            text: "Aiguillage automatique et relances divisent les temps de traitement.",
          },
          {
            title: "Zéro demande perdue",
            text: "Chaque demande a un statut, un responsable et une échéance.",
          },
          {
            title: "Un support mesurable",
            text: "Volumes, délais, satisfaction : pilotez l'activité de vos services avec des indicateurs.",
          },
        ],
      },
      metier: {
        intro:
          "Chaque métier a ses processus. Les modules métier d'Orbit digitalisent vos opérations spécifiques — hygiène, inventaires, merchandising, recettes — sans alourdir le quotidien des équipes.",
        subFeatures: [
          {
            title: "Hygiène & HACCP digitalisés",
            text: "Relevés de températures, contrôles sanitaires, traçabilité : tout est guidé, horodaté et archivé.",
          },
          {
            title: "Inventaires & merchandising",
            text: "Inventaires guidés, écarts remontés automatiquement, plans d'implantation avec photos de référence.",
          },
          {
            title: "Process 100% personnalisables",
            text: "Formulaires, workflows et validations sur mesure : Orbit épouse vos processus, pas l'inverse.",
          },
        ],
        benefits: [
          {
            title: "Conformité sans effort",
            text: "Les preuves sont collectées au fil de l'eau, prêtes pour vos audits.",
          },
          {
            title: "Des outils à votre image",
            text: "Chaque module s'adapte à vos métiers, vos standards et votre vocabulaire.",
          },
          {
            title: "Un déploiement progressif",
            text: "Activez les modules utiles aujourd'hui, ajoutez les autres demain.",
          },
        ],
      },
      magasin: {
        intro:
          "L'interface magasin concentre tout ce dont une équipe a besoin dans une application simple et rapide : sa journée, ses rituels, ses chiffres et ses demandes. Rien de plus, rien de moins.",
        subFeatures: [
          {
            title: "Ma journée & mes rituels",
            text: "Tâches prioritaires, check-lists guidées et rituels horodatés : chacun sait exactement quoi faire, et quand.",
          },
          {
            title: "Mes KPI en poche",
            text: "CA du jour, objectif, panier moyen : les chiffres essentiels du magasin visibles d'un coup d'œil.",
          },
          {
            title: "Demandes & documents",
            text: "Signaler un incident, suivre ses demandes, retrouver une procédure : tout se fait depuis le même écran.",
          },
        ],
        benefits: [
          {
            title: "Adoption immédiate",
            text: "Prise en main en moins d'une heure, sans formation lourde.",
          },
          {
            title: "Du temps pour les clients",
            text: "Moins d'administratif, plus de temps de vente et de conseil.",
          },
          {
            title: "Un terrain connecté",
            text: "Chaque équipe est reliée en direct au siège et aux services support.",
          },
        ],
      },
    },
    featuresPage: {
      eyebrow: "Découvrez Orbit. Fonctionnalité par fonctionnalité.",
      titleLines: ["Une plateforme. 5 modules.", "Tout votre réseau connecté."],
      blueFrom: 1,
      subtitle:
        "Orbit réunit dans un même environnement le pilotage opérationnel, la performance, les fonctions support, les outils métier et la vie du réseau.",
      ctaDemo: "Demander une démonstration",
      ctaVideo: "Voir la vidéo",
      annotation: "Du terrain au siège, toutes vos opérations dans une seule plateforme.",
      modulesNav: [
        { id: "intranet", label: "Intranet", action: "Informer" },
        { id: "operations", label: "Centre des opérations", action: "Piloter" },
        { id: "kpi", label: "Module KPI", action: "Mesurer" },
        { id: "support", label: "Module support", action: "Traiter" },
        { id: "metier", label: "Modules métier", action: "Exécuter" },
        { id: "magasin", label: "Interface magasin", action: "Agir" },
      ],
      modules: [
        {
          id: "intranet",
          chapter: "01",
          annotation: "Un réseau plus informé, plus engagé, plus fort !",
          titleMain: "Intranet",
          titleSub: "L'information du réseau, accessible à tous.",
          subtitle: "Un espace collaboratif pour informer, partager et engager l'ensemble de vos équipes.",
          points: [
            "Actualités et communications ciblées",
            "OrbitGram (réseau social interne)",
            "Annuaire collaborateurs",
            "Bibliothèque de ressources",
            "Événements et vie d'entreprise",
            "Recherche globale et favoris",
          ],
          cta: "Découvrir l'Intranet",
        },
        {
          id: "operations",
          chapter: "02",
          annotation: "Détecter → Prioriser → Agir → Suivre → Valider",
          titleMain: "Centre des opérations",
          titleSub: "Le cockpit quotidien des managers réseau.",
          subtitle:
            "Une vue complète pour savoir ce qui se passe sur le réseau, identifier les priorités et accompagner vos points de vente.",
          points: [
            "Carte et portefeuille de magasins",
            "Alertes et priorités",
            "Plans d'action et suivi",
            "Visites terrain et audits",
            "Animation réseau et objectifs",
            "Classements et benchmarks",
          ],
          cta: "Découvrir le centre des opérations",
        },
        {
          id: "kpi",
          chapter: "03",
          annotation: "Des données claires pour des décisions rapides.",
          titleMain: "Module KPI",
          titleSub: "De la donnée à l'action.",
          subtitle:
            "Des indicateurs clairs et fiables pour piloter la performance de votre réseau, du point de vente au siège.",
          points: [
            "CA, marge, objectifs, N-1, LFL",
            "Foodcost, achats, démarque",
            "Analyse multi-sites et comparatifs",
            "Tendances et projections",
            "Classements et détection des écarts",
            "Exports et analyse par l'IA Orbit",
          ],
          cta: "Découvrir le module KPI",
        },
        {
          id: "support",
          chapter: "04",
          annotation: "Une demande. Un suivi. Une résolution.",
          titleMain: "Module support",
          titleSub: "Le terrain demande, le support traite.",
          subtitle: "Un centre de demandes pour connecter efficacement vos points de vente et vos services support.",
          points: [
            "Demandes multi-services (RH, maintenance...)",
            "Suivi en temps réel et historique",
            "Affectation et gestion des SLA",
            "Échanges centralisés",
            "Notifications et relances",
            "Visibilité pour le terrain et les managers",
          ],
          cta: "Découvrir le module support",
        },
        {
          id: "metier",
          chapter: "05",
          annotation: "Des outils concrets pour vos réalités terrain.",
          titleMain: "Modules métier",
          titleSub: "Des outils adaptés à votre activité.",
          subtitle:
            "Des fonctionnalités spécifiques à votre métier (restauration, retail, franchise...) pour gérer vos processus opérationnels.",
          points: [
            "Hygiène & HACCP",
            "Inventaires & stocks",
            "Merchandising & contrôles",
            "Menus et recettes (restauration)",
            "Formulaires et workflows personnalisés",
            "Adaptation à vos métiers et standards",
          ],
          cta: "Découvrir les modules métier",
        },
        {
          id: "magasin",
          chapter: "06",
          annotation: "L'essentiel au bon moment, pour aller plus loin.",
          titleMain: "Interface magasin",
          titleSub: "Tout Orbit, simplifié pour le terrain.",
          subtitle:
            "Une interface claire et intuitive pour permettre aux équipes d'agir efficacement au quotidien.",
          points: [
            "Ma journée et tâches prioritaires",
            "Mes KPI",
            "Mes rituels et checklists",
            "Mes demandes",
            "Mes documents et actualités",
            "Accès aux outils métier",
          ],
          cta: "Découvrir l'interface magasin",
        },
      ],
      finalCta: {
        title: "Un seul écosystème.",
        title2: "Des expériences adaptées à chaque rôle.",
        badges: [
          { tag: "Terrain", label: "Agir au quotidien" },
          { tag: "Managers réseau", label: "Piloter et accompagner" },
          { tag: "Services support", label: "Traiter et collaborer" },
        ],
        button: "Demander une démonstration",
      },
    },
    solution: {
      eyebrow: "Une seule plateforme. Tout votre réseau.",
      titleLines: ["Orbit connecte", "ceux qui font,", "ceux qui pilotent", "et ceux qui accompagnent."],
      blueLine: 2,
      subtitle:
        "Du point de vente aux services support, Orbit fluidifie les échanges, structure l'information et transforme les actions quotidiennes en performance durable.",
      ctaDemo: "Demander une démonstration",
      ctaVideo: "Voir la vidéo",
      badges: ["Une plateforme tout-en-un", "Adoptée par les équipes terrain", "Des résultats concrets"],
      annotation: "Un réseau plus fort, ensemble !",
      cards: [
        { tag: "Terrain", label: "Agir simplement" },
        { tag: "Managers réseau", label: "Piloter le réseau" },
        { tag: "Services support", label: "Accompagner le terrain" },
      ],
      profilesChapter: "Trois profils, un objectif",
      profilesTitle: "Chaque profil a ses outils. Tous partagent la même information.",
      profiles: [
        {
          tag: "Terrain",
          name: "Agir simplement",
          desc: "Donner aux équipes les bons outils, au bon moment.",
          list: [
            "Rituels et tâches quotidiennes",
            "KPI du point de vente",
            "Inventaires",
            "Hygiène",
            "Documents et procédures",
            "Demandes et signalement d'incidents",
            "Informations et actualités réseau",
          ],
          quote: "Tout ce qu'il me faut au quotidien, dans une seule application.",
          author: "Équipe magasin",
          footer: "Moins d'outils, moins de friction, plus de temps pour le terrain.",
        },
        {
          tag: "Managers secteur / Animateurs",
          name: "Piloter le réseau",
          desc: "Voir, comprendre et agir sur l'ensemble de son secteur.",
          list: [
            "Vue multi-sites",
            "Suivi et analyse des KPI",
            "Comparaison des magasins",
            "Alertes terrain",
            "Plans d'action",
            "Visites et audits",
            "Classements",
            "Identification des magasins à accompagner",
            "Suivi des objectifs et des actions",
          ],
          quote: "J'ai une vision claire de mon secteur et je me concentre sur l'essentiel.",
          author: "Manager secteur",
          footer: "Une vision claire pour concentrer son temps là où il est réellement nécessaire.",
        },
        {
          tag: "Services support",
          name: "Accompagner le terrain",
          desc: "Transformer les fonctions support en partenaires opérationnels du réseau.",
          list: [
            "RH (recrutements, absences, formation)",
            "Maintenance (incidents, interventions)",
            "Achats (commandes, ruptures)",
            "Marketing (PLV, campagnes, communication)",
            "Qualité (audits, contrôles)",
            "Moyens Généraux",
            "Traitement des demandes et alertes",
            "Suivi des dossiers et actions",
            "Déploiement des offres et campagnes",
            "Appui aux managers",
          ],
          quote: "On traite les demandes plus vite et le terrain a de la visibilité.",
          author: "Service support",
          footer: "Un terrain sait où en est sa demande, le manager garde la visibilité, le support pilote son activité.",
        },
      ],
      flow: {
        eyebrow: "Un réseau fluide et connecté",
        title: "Du signalement à la résolution, tout le monde avance ensemble.",
        annotation: "Une information qui circule. Des actions qui avancent. Un réseau qui performe !",
        steps: [
          { label: "Le terrain", actions: "Signale · Réalise · Mesure" },
          { label: "Le management réseau", actions: "Analyse · Priorise · Accompagne" },
          { label: "Les services support", actions: "Traite · Déploie · Informe" },
        ],
        process: [
          "Le magasin signale une panne",
          "Le support reçoit la demande",
          "L'intervention est planifiée",
          "Le magasin est informé de l'avancement",
          "Le manager suit la résolution",
        ],
      },
      features: {
        eyebrow: "Des fonctionnalités très concrètes",
        title: "Tout ce qu'il faut pour faire avancer votre réseau.",
        items: [
          { title: "Piloter le terrain", text: "Tâches, KPI, inventaires, hygiène, incidents…" },
          { title: "Manager son réseau", text: "Suivi multi-sites, alertes, plans d'action, audits…" },
          { title: "Connecter les supports", text: "RH, maintenance, achats, marketing, qualité…" },
          { title: "Déployer les standards", text: "Procédures, campagnes, communication…" },
          { title: "Centraliser l'information", text: "Documents, échanges, historique…" },
          { title: "Mesurer la performance", text: "Indicateurs clairs et actionnables." },
        ],
      },
      cta: {
        title: "Prêt à connecter votre réseau ?",
        text: "Découvrez Orbit en action.",
        button: "Demander une démonstration",
      },
    },
    who: {
      eyebrow: "Des outils adaptés à chaque rôle. Un même objectif : un réseau plus performant.",
      titleLines: ["Orbit accompagne", "tous ceux qui font", "vivre le réseau."],
      blueFrom: 1,
      subtitle:
        "Du terrain au siège, chaque acteur dispose d'une expérience adaptée à ses besoins, avec une information partagée et des actions coordonnées.",
      annotation: "Des rôles différents, un même objectif !",
      heroBadges: [
        { tag: "Terrain", label: "Agir au quotidien" },
        { tag: "Managers", label: "Piloter le réseau" },
        { tag: "Support", label: "Accompagner" },
      ],
      users: {
        chapter: "01",
        title: "Pour quels utilisateurs ?",
        subtitle: "Une expérience adaptée à chaque acteur, pour plus d'efficacité au quotidien.",
        columns: [
          {
            tag: "Équipes terrain",
            role: "Responsables de point de vente",
            title: "Agir simplement au quotidien.",
            text: "Rituels, tâches, KPI magasin, inventaires, hygiène, documents, demandes, incidents, actualités réseau.",
            points: [
              "Une seule application",
              "Des tâches claires et prioritaires",
              "Un accès rapide aux informations",
              "Un lien direct avec le support",
            ],
            quote: "Tout ce dont j'ai besoin pour piloter mon point de vente.",
          },
          {
            tag: "Managers secteur",
            role: "Animateurs réseau",
            title: "Piloter, analyser et accompagner.",
            text: "Vue multi-sites, analyse des KPI, comparaison des magasins, objectifs, alertes, plans d'action, visites, audits, classements et détection des points de vente nécessitant un accompagnement.",
            points: [
              "Une vision globale de votre secteur",
              "Des alertes et recommandations",
              "Un suivi des actions et des visites",
              "Des outils pour animer et engager vos équipes",
            ],
            quote: "Je sais ce qui se passe et où concentrer mon temps.",
          },
          {
            tag: "Services support",
            role: "Siège et fonctions support",
            title: "Accompagner et faire avancer le réseau.",
            text: "RH, Maintenance, Achats, Marketing, Qualité, Moyens Généraux... Réception des demandes et alertes, traitement, affectation des actions, déploiement des campagnes et suivi de leur impact.",
            points: [
              "Une vision centralisée des demandes",
              "Un traitement plus rapide et plus efficace",
              "Une meilleure visibilité pour le terrain et les managers",
              "Des campagnes et standards déployés facilement",
            ],
            quote: "Je reste connecté aux besoins réels du terrain.",
          },
        ],
        flow: [
          { label: "Le terrain", actions: "Signale · Réalise · Mesure" },
          { label: "Les managers", actions: "Analyse · Priorise · Accompagne" },
          { label: "Les services support", actions: "Traite · Déploie · Informe" },
        ],
      },
      clients: {
        chapter: "02",
        title: "Pour quels clients ?",
        subtitle: "Orbit s'adapte à votre métier, votre organisation et vos ambitions.",
        annotation: "Des solutions pour tous les réseaux de points de vente !",
        more: "En savoir plus",
        cards: [
          {
            slug: "restauration",
            title: "Restauration & Food Service",
            text: "Restaurants, restauration rapide, franchises, coffee shops, corners, concepts food, réseaux multi-sites.",
            tags: ["Performance", "Inventaires", "HACCP", "Équipes", "Achats"],
          },
          {
            slug: "retail-alimentaire",
            title: "Retail alimentaire",
            text: "Supermarchés, magasins de proximité, réseaux spécialisés, corners et shop-in-shop.",
            tags: ["Stocks", "Ruptures", "Merchandising", "Opérations", "Maintenance"],
          },
          {
            slug: "retail-specialise",
            title: "Retail spécialisé",
            text: "Mode, beauté, maison, sport, loisirs, services et autres réseaux de boutiques.",
            tags: ["CA & KPI", "Merchandising", "Audits", "Campagnes", "RH"],
          },
          {
            slug: "reseaux-franchises",
            title: "Réseaux & franchises multi-sites",
            text: "Groupes, franchises, réseaux intégrés ou affiliés, en France ou à l'international.",
            tags: ["Standards", "Conformité", "Animation réseau", "Expansion", "Pilotage global"],
          },
        ],
      },
      stats: {
        title: "Votre réseau est unique.",
        title2: "Orbit s'y adapte.",
        items: [
          "10 à 500+ points de vente",
          "Tous secteurs d'activité",
          "Une configuration sur mesure",
          "Une équipe à vos côtés à chaque étape",
        ],
      },
      testimonial: {
        quote:
          "Orbit s'adapte parfaitement à notre organisation multi-enseignes. Chaque équipe y trouve ce dont elle a besoin.",
        name: "Thomas R.",
        role: "Directeur des opérations",
        ctaTitle: "Et si on parlait de votre projet ?",
        ctaText: "Découvrez comment Orbit s'adapte à votre réseau.",
        ctaButton: "Demander une démonstration",
      },
    },
    sectorPages: {
      restauration: {
        name: "Restauration & Food Service",
        hero: "Pilotez vos restaurants avec des outils pensés pour le rythme du service.",
        intro:
          "Service, hygiène, inventaires, équipes : la restauration ne laisse aucune place à l'à-peu-près. Orbit centralise vos opérations pour que chaque service soit maîtrisé, de l'ouverture au rush du soir.",
        tags: ["Performance", "Inventaires", "HACCP", "Équipes", "Achats"],
        challengesTitle: "Vos enjeux au quotidien",
        challenges: [
          "Rituels HACCP et contrôles d'hygiène chronophages",
          "Inventaires et pertes difficiles à suivre",
          "Turnover élevé et formation continue des équipes",
          "Standards de marque variables d'un restaurant à l'autre",
        ],
        solutionsTitle: "Ce qu'Orbit apporte à vos restaurants",
        solutions: [
          "Check-lists HACCP digitales, horodatées, avec photos à l'appui",
          "Inventaires guidés et remontée automatique des écarts",
          "Prise en main en moins d'une heure, idéale pour les nouvelles recrues",
          "Procédures et campagnes déployées en un clic sur tout le réseau",
        ],
        ctaTitle: "Prêt à équiper vos restaurants ?",
        ctaText: "Découvrez Orbit en action sur vos cas d'usage restauration.",
        ctaButton: "Demander une démonstration",
      },
      "retail-alimentaire": {
        name: "Retail alimentaire",
        hero: "Simplifiez la gestion de vos magasins et fluidifiez vos opérations quotidiennes.",
        intro:
          "Ruptures, stocks, merchandising, maintenance : vos équipes jonglent en permanence. Orbit leur donne une vision claire de leurs priorités et remonte l'information au siège en temps réel.",
        tags: ["Stocks", "Ruptures", "Merchandising", "Opérations", "Maintenance"],
        challengesTitle: "Vos enjeux au quotidien",
        challenges: [
          "Ruptures en rayon détectées trop tard",
          "Merchandising et implantations difficiles à faire respecter",
          "Incidents et maintenance remontés par téléphone ou email",
          "Opérations commerciales inégalement déployées",
        ],
        solutionsTitle: "Ce qu'Orbit apporte à vos magasins",
        solutions: [
          "Signalement des ruptures en 10 secondes, avec photo",
          "Plans d'implantation et photos de référence dans l'application",
          "Incidents centralisés, affectés et suivis jusqu'à résolution",
          "Déploiement d'opérations suivi magasin par magasin",
        ],
        ctaTitle: "Prêt à équiper vos magasins ?",
        ctaText: "Découvrez Orbit en action sur vos cas d'usage retail alimentaire.",
        ctaButton: "Demander une démonstration",
      },
      "retail-specialise": {
        name: "Retail spécialisé",
        hero: "Une solution flexible pour tous les concepts de commerce spécialisé.",
        intro:
          "Mode, beauté, maison, sport : chaque concept a ses codes. Orbit s'adapte à vos processus métier tout en gardant une expérience simple pour vos équipes en boutique.",
        tags: ["CA & KPI", "Merchandising", "Audits", "Campagnes", "RH"],
        challengesTitle: "Vos enjeux au quotidien",
        challenges: [
          "KPI dispersés entre caisse, tableurs et emails",
          "Audits terrain longs à consolider et à exploiter",
          "Campagnes marketing inégalement mises en place",
          "Communication siège-boutiques fragmentée",
        ],
        solutionsTitle: "Ce qu'Orbit apporte à vos boutiques",
        solutions: [
          "KPI consolidés en temps réel, comparables entre boutiques",
          "Audits digitalisés avec score et plan d'action automatique",
          "Campagnes déployées avec accusé de mise en place photo",
          "Un canal unique pour toutes les communications réseau",
        ],
        ctaTitle: "Prêt à équiper vos boutiques ?",
        ctaText: "Découvrez Orbit en action sur vos cas d'usage retail spécialisé.",
        ctaButton: "Demander une démonstration",
      },
      "reseaux-franchises": {
        name: "Réseaux & franchises multi-sites",
        hero: "Pilotez vos réseaux multi-sites et franchises à grande échelle.",
        intro:
          "Groupes, réseaux intégrés ou affiliés : plus votre réseau grandit, plus la cohérence devient un défi. Orbit fait circuler vos standards et votre information, en France comme à l'international.",
        tags: ["Standards", "Conformité", "Animation réseau", "Expansion", "Pilotage global"],
        challengesTitle: "Vos enjeux au quotidien",
        challenges: [
          "Standards de marque difficiles à garantir partout",
          "Visibilité limitée sur les points de vente éloignés",
          "Animation du réseau reposant sur les seuls animateurs",
          "Expansion freinée par des processus non industrialisés",
        ],
        solutionsTitle: "Ce qu'Orbit apporte à votre réseau",
        solutions: [
          "Standards digitalisés, conformité mesurée en continu",
          "Vue multi-sites consolidée, du siège au dernier franchisé",
          "Classements, défis et actualités pour engager le réseau",
          "Un modèle opérationnel prêt pour vos prochaines ouvertures",
        ],
        ctaTitle: "Prêt à connecter votre réseau ?",
        ctaText: "Découvrez comment Orbit passe à l'échelle avec vous.",
        ctaButton: "Demander une démonstration",
      },
    },
  },
  en: {
    blog: {
      eyebrow: "Resources",
      title: "Guides & articles to run your network",
      subtitle: "Field advice, best practices and lessons learned for restaurant and retail networks.",
      readMore: "Read the article",
      back: "All articles",
      empty: "No articles published yet.",
      publishedOn: "Published on",
      ctaTitle: "Want to go further?",
      ctaText: "See how Orbit brings these best practices to life in your network.",
      ctaButton: "Book a demo",
    },
    modulePages: {
      common: {
        subFeaturesTitle: "What you can do",
        benefitsTitle: "Why your teams will love it",
        backLink: "All modules",
        nextLabel: "Next module",
        demoButton: "Book a demo",
      },
      intranet: {
        intro:
          "No more information lost between emails, notice boards and chat groups. The Orbit Intranet centralises your entire network life in a single space, accessible to every employee according to their role.",
        subFeatures: [
          {
            title: "Targeted communications",
            text: "Deliver the right information to the right audience: by store, region, role or brand, with read tracking.",
          },
          {
            title: "OrbitGram, the internal social network",
            text: "Window display photos, wins, challenges between stores: your teams share their successes and engage every day.",
          },
          {
            title: "Resources & directory",
            text: "Documents, procedures, training and contacts: everything is found in seconds with global search and favourites.",
          },
        ],
        benefits: [
          {
            title: "Information that reaches the field",
            text: "Measure who read what, and follow up with stores that haven't seen it.",
          },
          {
            title: "More engaged teams",
            text: "Public recognition and challenges create a genuine network life.",
          },
          {
            title: "Zero lost emails",
            text: "All communications are centralised, searchable and archived.",
          },
        ],
      },
      operations: {
        intro:
          "The Operations Centre is the command post of your area managers and network animators: a consolidated view of every store, prioritised alerts, and tools to act without waiting.",
        subFeatures: [
          {
            title: "Multi-site map & portfolio",
            text: "See the status of every store on a real-time map: compliance, performance, ongoing incidents.",
          },
          {
            title: "Alerts & action plans",
            text: "Deviations surface automatically. Assign actions, set deadlines and track their progress.",
          },
          {
            title: "Visits, audits & benchmarks",
            text: "Prepare your visits, digitise your audit grids and compare stores to spread best practices.",
          },
        ],
        benefits: [
          {
            title: "Obvious priorities",
            text: "Your managers know every morning where to focus their time, and why.",
          },
          {
            title: "Tracking without blind spots",
            text: "Every action is tracked until validation, store by store.",
          },
          {
            title: "A network that improves",
            text: "Rankings motivate, and top performers inspire the rest.",
          },
        ],
      },
      kpi: {
        intro:
          "Stop chasing numbers. The KPI module automatically consolidates your sales, margin and activity data, making it readable at every level of your organisation.",
        subFeatures: [
          {
            title: "Consolidated business metrics",
            text: "Revenue, margin, food cost, shrinkage, targets, N-1 and like-for-like: your source data is reliable and harmonised.",
          },
          {
            title: "Comparisons & rankings",
            text: "Compare stores, areas and periods in one click. Instantly spot performance gaps.",
          },
          {
            title: "Analysis by Orbit AI",
            text: "Ask your questions in plain language: AI analyses your data, explains deviations and suggests recommendations.",
          },
        ],
        benefits: [
          {
            title: "Faster decisions",
            text: "Clear, up-to-date data, without waiting for weekly reports.",
          },
          {
            title: "A common language",
            text: "HQ and field talk about the same numbers, at the same time.",
          },
          {
            title: "AI serving the field",
            text: "Automatic recommendations turn analysis into concrete actions.",
          },
        ],
      },
      support: {
        intro:
          "The support module replaces email chains and scattered calls with a single request centre: every field request is tracked, assigned and followed through to resolution.",
        subFeatures: [
          {
            title: "Multi-service requests",
            text: "HR, maintenance, purchasing, marketing, quality: the store submits its request, Orbit routes it to the right service.",
          },
          {
            title: "SLA & smart assignment",
            text: "Priorities, processing deadlines and automatic assignments: nothing falls through the cracks.",
          },
          {
            title: "Timeline & transparency",
            text: "The store tracks its request in real time; the manager keeps visibility across the whole area.",
          },
        ],
        benefits: [
          {
            title: "Dramatically shorter lead times",
            text: "Automatic routing and reminders slash processing times.",
          },
          {
            title: "Zero lost requests",
            text: "Every request has a status, an owner and a deadline.",
          },
          {
            title: "A measurable support",
            text: "Volumes, lead times, satisfaction: steer your services with metrics.",
          },
        ],
      },
      metier: {
        intro:
          "Every trade has its own processes. Orbit's business modules digitise your specific operations — hygiene, inventories, merchandising, recipes — without weighing down your teams' daily work.",
        subFeatures: [
          {
            title: "Digitised hygiene & HACCP",
            text: "Temperature readings, sanitary checks, traceability: everything is guided, timestamped and archived.",
          },
          {
            title: "Inventories & merchandising",
            text: "Guided inventories, variances reported automatically, planograms with reference photos.",
          },
          {
            title: "100% customisable processes",
            text: "Custom forms, workflows and validations: Orbit fits your processes, not the other way around.",
          },
        ],
        benefits: [
          {
            title: "Effortless compliance",
            text: "Evidence is collected as you go, ready for your audits.",
          },
          {
            title: "Tools in your image",
            text: "Every module adapts to your trades, your standards and your vocabulary.",
          },
          {
            title: "Progressive rollout",
            text: "Activate the modules you need today, add the others tomorrow.",
          },
        ],
      },
      magasin: {
        intro:
          "The store interface concentrates everything a team needs in one simple, fast app: their day, their rituals, their numbers and their requests. Nothing more, nothing less.",
        subFeatures: [
          {
            title: "My day & my rituals",
            text: "Priority tasks, guided checklists and timestamped rituals: everyone knows exactly what to do, and when.",
          },
          {
            title: "My KPIs in my pocket",
            text: "Today's revenue, target, average basket: the store's essential numbers at a glance.",
          },
          {
            title: "Requests & documents",
            text: "Report an incident, track requests, find a procedure: everything from the same screen.",
          },
        ],
        benefits: [
          {
            title: "Immediate adoption",
            text: "Up and running in under an hour, no heavy training.",
          },
          {
            title: "More time for customers",
            text: "Less admin, more selling and advising time.",
          },
          {
            title: "A connected field",
            text: "Every team is directly linked to HQ and support services.",
          },
        ],
      },
    },
    featuresPage: {
      eyebrow: "Discover Orbit. Feature by feature.",
      titleLines: ["One platform. 5 modules.", "Your whole network connected."],
      blueFrom: 1,
      subtitle:
        "Orbit brings together operational steering, performance, support functions, business tools and network life in a single environment.",
      ctaDemo: "Book a demo",
      ctaVideo: "Watch the video",
      annotation: "From field to HQ, all your operations in one platform.",
      modulesNav: [
        { id: "intranet", label: "Intranet", action: "Inform" },
        { id: "operations", label: "Operations centre", action: "Steer" },
        { id: "kpi", label: "KPI module", action: "Measure" },
        { id: "support", label: "Support module", action: "Process" },
        { id: "metier", label: "Business modules", action: "Execute" },
        { id: "magasin", label: "Store interface", action: "Act" },
      ],
      modules: [
        {
          id: "intranet",
          chapter: "01",
          annotation: "A better informed, more engaged, stronger network!",
          titleMain: "Intranet",
          titleSub: "Network information, accessible to all.",
          subtitle: "A collaborative space to inform, share and engage all your teams.",
          points: [
            "News and targeted communications",
            "OrbitGram (internal social network)",
            "Employee directory",
            "Resource library",
            "Events and company life",
            "Global search and favourites",
          ],
          cta: "Discover the Intranet",
        },
        {
          id: "operations",
          chapter: "02",
          annotation: "Detect → Prioritise → Act → Track → Validate",
          titleMain: "Operations centre",
          titleSub: "The daily cockpit of network managers.",
          subtitle:
            "A complete view to know what is happening across the network, identify priorities and support your stores.",
          points: [
            "Store map and portfolio",
            "Alerts and priorities",
            "Action plans and tracking",
            "Field visits and audits",
            "Network engagement and targets",
            "Rankings and benchmarks",
          ],
          cta: "Discover the operations centre",
        },
        {
          id: "kpi",
          chapter: "03",
          annotation: "Clear data for fast decisions.",
          titleMain: "KPI module",
          titleSub: "From data to action.",
          subtitle:
            "Clear, reliable metrics to drive your network's performance, from the point of sale to HQ.",
          points: [
            "Revenue, margin, targets, N-1, LFL",
            "Food cost, purchasing, shrinkage",
            "Multi-site analysis and comparisons",
            "Trends and projections",
            "Rankings and gap detection",
            "Exports and analysis by Orbit AI",
          ],
          cta: "Discover the KPI module",
        },
        {
          id: "support",
          chapter: "04",
          annotation: "One request. One tracking. One resolution.",
          titleMain: "Support module",
          titleSub: "The field asks, support processes.",
          subtitle: "A request centre to efficiently connect your stores and your support services.",
          points: [
            "Multi-service requests (HR, maintenance…)",
            "Real-time tracking and history",
            "Assignment and SLA management",
            "Centralised conversations",
            "Notifications and reminders",
            "Visibility for field and managers",
          ],
          cta: "Discover the support module",
        },
        {
          id: "metier",
          chapter: "05",
          annotation: "Concrete tools for your field realities.",
          titleMain: "Business modules",
          titleSub: "Tools adapted to your activity.",
          subtitle:
            "Features specific to your trade (restaurants, retail, franchise…) to manage your operational processes.",
          points: [
            "Hygiene & HACCP",
            "Inventories & stock",
            "Merchandising & checks",
            "Menus and recipes (restaurants)",
            "Custom forms and workflows",
            "Adapted to your trades and standards",
          ],
          cta: "Discover the business modules",
        },
        {
          id: "magasin",
          chapter: "06",
          annotation: "The essentials at the right time, to go further.",
          titleMain: "Store interface",
          titleSub: "All of Orbit, simplified for the field.",
          subtitle: "A clear, intuitive interface so teams can act efficiently every day.",
          points: [
            "My day and priority tasks",
            "My KPIs",
            "My rituals and checklists",
            "My requests",
            "My documents and news",
            "Access to business tools",
          ],
          cta: "Discover the store interface",
        },
      ],
      finalCta: {
        title: "One single ecosystem.",
        title2: "Experiences tailored to every role.",
        badges: [
          { tag: "Field", label: "Act every day" },
          { tag: "Network managers", label: "Steer and support" },
          { tag: "Support services", label: "Process and collaborate" },
        ],
        button: "Book a demo",
      },
    },
    solution: {
      eyebrow: "One platform. Your whole network.",
      titleLines: ["Orbit connects", "those who do,", "those who manage", "and those who support."],
      blueLine: 2,
      subtitle:
        "From the point of sale to support services, Orbit streamlines communication, structures information and turns daily actions into lasting performance.",
      ctaDemo: "Book a demo",
      ctaVideo: "Watch the video",
      badges: ["One all-in-one platform", "Adopted by field teams", "Concrete results"],
      annotation: "A stronger network, together!",
      cards: [
        { tag: "Field", label: "Act simply" },
        { tag: "Network managers", label: "Drive the network" },
        { tag: "Support services", label: "Support the field" },
      ],
      profilesChapter: "Three profiles, one goal",
      profilesTitle: "Every profile gets its tools. Everyone shares the same information.",
      profiles: [
        {
          tag: "Field",
          name: "Act simply",
          desc: "Give teams the right tools, at the right time.",
          list: [
            "Daily rituals and tasks",
            "Store KPIs",
            "Inventories",
            "Hygiene",
            "Documents and procedures",
            "Requests and incident reports",
            "Network news and updates",
          ],
          quote: "Everything I need every day, in a single app.",
          author: "Store team",
          footer: "Fewer tools, less friction, more time for the field.",
        },
        {
          tag: "Area managers / Animators",
          name: "Drive the network",
          desc: "See, understand and act across your entire area.",
          list: [
            "Multi-site view",
            "KPI tracking and analysis",
            "Store comparisons",
            "Field alerts",
            "Action plans",
            "Visits and audits",
            "Rankings",
            "Identification of stores needing support",
            "Tracking of goals and actions",
          ],
          quote: "I have a clear view of my area and I focus on what matters.",
          author: "Area manager",
          footer: "A clear vision to focus time where it is truly needed.",
        },
        {
          tag: "Support services",
          name: "Support the field",
          desc: "Turn support functions into operational partners of the network.",
          list: [
            "HR (hiring, absences, training)",
            "Maintenance (incidents, interventions)",
            "Purchasing (orders, stockouts)",
            "Marketing (POS, campaigns, communication)",
            "Quality (audits, checks)",
            "General services",
            "Request and alert handling",
            "Case and action tracking",
            "Offer and campaign rollouts",
            "Support for managers",
          ],
          quote: "We handle requests faster and the field has visibility.",
          author: "Support team",
          footer: "The field knows where its request stands, the manager keeps visibility, support runs its activity.",
        },
      ],
      flow: {
        eyebrow: "A smooth, connected network",
        title: "From report to resolution, everyone moves forward together.",
        annotation: "Information that flows. Actions that move. A network that performs!",
        steps: [
          { label: "The field", actions: "Reports · Executes · Measures" },
          { label: "Network management", actions: "Analyses · Prioritises · Supports" },
          { label: "Support services", actions: "Handles · Rolls out · Informs" },
        ],
        process: [
          "The store reports a breakdown",
          "Support receives the request",
          "The intervention is scheduled",
          "The store is kept informed",
          "The manager tracks the resolution",
        ],
      },
      features: {
        eyebrow: "Very concrete features",
        title: "Everything you need to move your network forward.",
        items: [
          { title: "Run the field", text: "Tasks, KPIs, inventories, hygiene, incidents…" },
          { title: "Manage your network", text: "Multi-site tracking, alerts, action plans, audits…" },
          { title: "Connect support teams", text: "HR, maintenance, purchasing, marketing, quality…" },
          { title: "Roll out standards", text: "Procedures, campaigns, communication…" },
          { title: "Centralise information", text: "Documents, conversations, history…" },
          { title: "Measure performance", text: "Clear, actionable metrics." },
        ],
      },
      cta: {
        title: "Ready to connect your network?",
        text: "See Orbit in action.",
        button: "Book a demo",
      },
    },
    who: {
      eyebrow: "Tools adapted to every role. One shared goal: a higher-performing network.",
      titleLines: ["Orbit supports", "everyone who brings", "the network to life."],
      blueFrom: 1,
      subtitle:
        "From the field to headquarters, every stakeholder gets an experience tailored to their needs, with shared information and coordinated actions.",
      annotation: "Different roles, one shared goal!",
      heroBadges: [
        { tag: "Field", label: "Act every day" },
        { tag: "Managers", label: "Drive the network" },
        { tag: "Support", label: "Assist teams" },
      ],
      users: {
        chapter: "01",
        title: "Who is it for?",
        subtitle: "An experience tailored to every stakeholder, for greater day-to-day efficiency.",
        columns: [
          {
            tag: "Field teams",
            role: "Store managers",
            title: "Act simply, every day.",
            text: "Rituals, tasks, store KPIs, inventories, hygiene, documents, requests, incidents, network news.",
            points: [
              "One single application",
              "Clear, prioritised tasks",
              "Fast access to information",
              "A direct line to support",
            ],
            quote: "Everything I need to run my store.",
          },
          {
            tag: "Area managers",
            role: "Network animators",
            title: "Manage, analyse and support.",
            text: "Multi-site view, KPI analysis, store comparisons, targets, alerts, action plans, visits, audits, rankings and detection of stores needing support.",
            points: [
              "A global view of your area",
              "Alerts and recommendations",
              "Tracking of actions and visits",
              "Tools to engage and motivate your teams",
            ],
            quote: "I know what is happening and where to focus my time.",
          },
          {
            tag: "Support services",
            role: "HQ and support functions",
            title: "Support and move the network forward.",
            text: "HR, Maintenance, Purchasing, Marketing, Quality, General Services... Receive requests and alerts, process them, assign actions, roll out campaigns and track their impact.",
            points: [
              "A centralised view of requests",
              "Faster, more efficient processing",
              "Better visibility for field and managers",
              "Campaigns and standards rolled out easily",
            ],
            quote: "I stay connected to the field's real needs.",
          },
        ],
        flow: [
          { label: "The field", actions: "Reports · Executes · Measures" },
          { label: "The managers", actions: "Analyse · Prioritise · Support" },
          { label: "Support services", actions: "Handle · Roll out · Inform" },
        ],
      },
      clients: {
        chapter: "02",
        title: "Which clients?",
        subtitle: "Orbit adapts to your business, your organisation and your ambitions.",
        annotation: "Solutions for every store network!",
        more: "Learn more",
        cards: [
          {
            slug: "restauration",
            title: "Restaurants & Food Service",
            text: "Restaurants, quick service, franchises, coffee shops, corners, food concepts, multi-site networks.",
            tags: ["Performance", "Inventories", "HACCP", "Teams", "Purchasing"],
          },
          {
            slug: "retail-alimentaire",
            title: "Food retail",
            text: "Supermarkets, convenience stores, specialised networks, corners and shop-in-shops.",
            tags: ["Stock", "Stockouts", "Merchandising", "Operations", "Maintenance"],
          },
          {
            slug: "retail-specialise",
            title: "Specialty retail",
            text: "Fashion, beauty, home, sport, leisure, services and other boutique networks.",
            tags: ["Revenue & KPIs", "Merchandising", "Audits", "Campaigns", "HR"],
          },
          {
            slug: "reseaux-franchises",
            title: "Multi-site networks & franchises",
            text: "Groups, franchises, integrated or affiliated networks, in France and internationally.",
            tags: ["Standards", "Compliance", "Network engagement", "Expansion", "Global steering"],
          },
        ],
      },
      stats: {
        title: "Your network is unique.",
        title2: "Orbit adapts.",
        items: [
          "10 to 500+ points of sale",
          "All business sectors",
          "A tailor-made configuration",
          "A team by your side at every step",
        ],
      },
      testimonial: {
        quote:
          "Orbit adapts perfectly to our multi-brand organisation. Every team finds what it needs.",
        name: "Thomas R.",
        role: "Operations director",
        ctaTitle: "Shall we talk about your project?",
        ctaText: "Discover how Orbit adapts to your network.",
        ctaButton: "Book a demo",
      },
    },
    sectorPages: {
      restauration: {
        name: "Restaurants & Food Service",
        hero: "Run your restaurants with tools designed for the pace of service.",
        intro:
          "Service, hygiene, inventories, teams: food service leaves no room for guesswork. Orbit centralises your operations so every shift is under control, from opening to the evening rush.",
        tags: ["Performance", "Inventories", "HACCP", "Teams", "Purchasing"],
        challengesTitle: "Your daily challenges",
        challenges: [
          "Time-consuming HACCP rituals and hygiene checks",
          "Inventories and losses that are hard to track",
          "High turnover and continuous team training",
          "Brand standards that vary from one restaurant to another",
        ],
        solutionsTitle: "What Orbit brings to your restaurants",
        solutions: [
          "Digital HACCP checklists, timestamped, with photo proof",
          "Guided inventories with automatic variance reporting",
          "Under one hour to onboard — ideal for new hires",
          "Procedures and campaigns rolled out in one click network-wide",
        ],
        ctaTitle: "Ready to equip your restaurants?",
        ctaText: "See Orbit in action on your food-service use cases.",
        ctaButton: "Book a demo",
      },
      "retail-alimentaire": {
        name: "Food retail",
        hero: "Simplify store management and streamline your daily operations.",
        intro:
          "Stockouts, inventory, merchandising, maintenance: your teams juggle constantly. Orbit gives them a clear view of their priorities and reports information back to HQ in real time.",
        tags: ["Stock", "Stockouts", "Merchandising", "Operations", "Maintenance"],
        challengesTitle: "Your daily challenges",
        challenges: [
          "Shelf stockouts detected too late",
          "Merchandising and planograms hard to enforce",
          "Incidents and maintenance reported by phone or email",
          "Commercial operations unevenly deployed",
        ],
        solutionsTitle: "What Orbit brings to your stores",
        solutions: [
          "Stockout reporting in 10 seconds, with photo",
          "Planograms and reference photos right in the app",
          "Centralised incidents, assigned and tracked to resolution",
          "Operation rollouts tracked store by store",
        ],
        ctaTitle: "Ready to equip your stores?",
        ctaText: "See Orbit in action on your food-retail use cases.",
        ctaButton: "Book a demo",
      },
      "retail-specialise": {
        name: "Specialty retail",
        hero: "A flexible solution for every specialty retail concept.",
        intro:
          "Fashion, beauty, home, sport: every concept has its codes. Orbit adapts to your business processes while keeping the experience simple for your in-store teams.",
        tags: ["Revenue & KPIs", "Merchandising", "Audits", "Campaigns", "HR"],
        challengesTitle: "Your daily challenges",
        challenges: [
          "KPIs scattered across POS, spreadsheets and emails",
          "Field audits that are slow to consolidate and exploit",
          "Marketing campaigns unevenly implemented",
          "Fragmented HQ-to-store communication",
        ],
        solutionsTitle: "What Orbit brings to your boutiques",
        solutions: [
          "KPIs consolidated in real time, comparable across boutiques",
          "Digital audits with score and automatic action plan",
          "Campaigns rolled out with photo proof of setup",
          "One single channel for all network communication",
        ],
        ctaTitle: "Ready to equip your boutiques?",
        ctaText: "See Orbit in action on your specialty-retail use cases.",
        ctaButton: "Book a demo",
      },
      "reseaux-franchises": {
        name: "Multi-site networks & franchises",
        hero: "Run your multi-site networks and franchises at scale.",
        intro:
          "Groups, integrated or affiliated networks: the bigger your network grows, the harder consistency becomes. Orbit circulates your standards and information, in France and internationally.",
        tags: ["Standards", "Compliance", "Network engagement", "Expansion", "Global steering"],
        challengesTitle: "Your daily challenges",
        challenges: [
          "Brand standards hard to guarantee everywhere",
          "Limited visibility on remote points of sale",
          "Network engagement resting solely on animators",
          "Expansion slowed by non-industrialised processes",
        ],
        solutionsTitle: "What Orbit brings to your network",
        solutions: [
          "Digitalised standards, compliance measured continuously",
          "Consolidated multi-site view, from HQ to the last franchisee",
          "Rankings, challenges and news to engage the network",
          "An operating model ready for your next openings",
        ],
        ctaTitle: "Ready to connect your network?",
        ctaText: "Discover how Orbit scales with you.",
        ctaButton: "Book a demo",
      },
    },
  },
};
